import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, useHistory, useLocation } from 'react-router';
import { createLocation } from 'history';
import { useUpdatePlaylistContent } from 'actions/playlists';
import EditorSaveStatus from 'components/EditorSaveStatus';
import StickyBox from 'components/StickyBox';
import TooltipButton from 'components/TooltipButton';
import Flex from 'components/Flex';
import Card from 'components/Card';
import { formatContentManagerPayload } from '../Editor/utils/formatContentManagerPayload';
import { MANAGE_CONTENT_ROUTES } from '..';
export function StickyFooter(_ref) {
  var reducerState = _ref.reducerState,
    hasPlaylistChanges = _ref.hasPlaylistChanges,
    initialPlaylistData = _ref.initialPlaylistData;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _reducerState = _slicedToArray(reducerState, 3),
    content = _reducerState[0].content,
    dispatch = _reducerState[1],
    undoHistory = _reducerState[2];
  var location = useLocation();
  var history = useHistory();
  var _useUpdatePlaylistCon = useUpdatePlaylistContent({
      playlistId: initialPlaylistData.id
    }),
    updatePlaylistContent = _useUpdatePlaylistCon.updatePlaylistContent,
    isSaving = _useUpdatePlaylistCon.isLoading;
  function saveContentChanges() {
    return _saveContentChanges.apply(this, arguments);
  }
  function _saveContentChanges() {
    _saveContentChanges = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var initialContentIds, patchPayload;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // Get the ids of the content initially in the playlist (before any changes)
            initialContentIds = initialPlaylistData.content.map(function (_ref2) {
              var id = _ref2.id;
              return id;
            });
            patchPayload = formatContentManagerPayload({
              content: content,
              initialContentIds: initialContentIds
            });
            _context.next = 4;
            return updatePlaylistContent(patchPayload);
          case 4:
            // Clear selected items
            history.push(createLocation(location.pathname));
            // Reset content manager state
            dispatch({
              type: 'RESET'
            });
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _saveContentChanges.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement(StickyBox, {
    placement: "bottom",
    borderRadius: "large",
    mt: "m"
  }, /*#__PURE__*/React.createElement(Card, {
    px: "m",
    py: "s"
  }, /*#__PURE__*/React.createElement(EditorSaveStatus, {
    onSave: saveContentChanges,
    canSaveChanges: hasPlaylistChanges,
    hasUnsavedChanges: hasPlaylistChanges,
    isSaving: isSaving,
    noUnsavedChangesText: t('state_no_changes_since_last_save'),
    stateOptions: /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(TooltipButton, {
      iconOnly: true,
      icon: "undo",
      variant: "transparent",
      isDisabled: undoHistory.past.length === 0,
      onClick: function onClick() {
        return dispatch({
          type: 'UNDO'
        });
      }
    }, t('actions_undo')), /*#__PURE__*/React.createElement(TooltipButton, {
      iconOnly: true,
      icon: "redo",
      variant: "transparent",
      isDisabled: undoHistory.future.length === 0,
      onClick: function onClick() {
        return dispatch({
          type: 'REDO'
        });
      }
    }, t('actions_redo'))),
    previewOptions: {
      previewLocation: generatePath(MANAGE_CONTENT_ROUTES.preview, {
        playlistId: initialPlaylistData.id
      }),
      exitLocation: generatePath(MANAGE_CONTENT_ROUTES.root, {
        playlistId: initialPlaylistData.id
      })
    },
    justifyContent: ['space-between', 'space-evenly'],
    breakpoints: "xxs"
  })));
}